/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./dx-base-modal.component";
import * as i2 from "ng2-semantic-ui/dist/modules/modal/classes/modal-controls";
var styles_DxBaseModalComponent = [];
var RenderType_DxBaseModalComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_DxBaseModalComponent, data: {} });
export { RenderType_DxBaseModalComponent as RenderType_DxBaseModalComponent };
export function View_DxBaseModalComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_DxBaseModalComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "dx-base-modal", [], null, null, null, View_DxBaseModalComponent_0, RenderType_DxBaseModalComponent)), i0.ɵdid(1, 245760, null, 0, i1.DxBaseModalComponent, [i2.Modal], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var DxBaseModalComponentNgFactory = i0.ɵccf("dx-base-modal", i1.DxBaseModalComponent, View_DxBaseModalComponent_Host_0, {}, {}, []);
export { DxBaseModalComponentNgFactory as DxBaseModalComponentNgFactory };
